import { useControls, folder } from 'leva';

export function useVentilationControls() {
  return useControls(
    'Debug Ventilation',
    () => ({
      enabled: false,
      Material: folder(
        {
          color: {
            value: '#0036ff',
          },
          transparent: true,
          depthTest: false,
        },
        {
          collapsed: true,
        },
      ),
    }),
    {
      collapsed: true,
    },
  );
}
